import {useState} from 'react';
import {useAuthStore} from '@/stores/authStore';
import {authService} from '@/services/authService';
import {LoginCredentials} from "@/types/auth.types";

export const useAuth = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const {setAuth, clearAuth, isAuthenticated, user} = useAuthStore();

    const login = async (email: string, password: string) => {
        try {
            setIsLoading(true);
            setError(null);
            const credentials: LoginCredentials = {email, password};
            const tokens = await authService.login(credentials);
            useAuthStore.getState().updateTokens(tokens);
            const user = await authService.getUserInfo();
            setAuth(user, tokens);
            return true;

        } catch (err: unknown) {
            const errorMessage = err instanceof Error
                ? err.message
                : 'Erreur inconnue lors de la connexion.';

            setError(errorMessage);
            console.error('Erreur lors de la connexion :', err);
            return false;
        } finally {
            setIsLoading(false);
        }
    };

    const logout = () => {
        clearAuth();
    };

    return {
        user,
        login,
        logout,
        isAuthenticated,
        isLoading,
        error
    };
};
